import axios from 'axios'

const API_URL = process.env.REACT_APP_ENV === 'prod' ? process.env.REACT_APP_API_PROD_URL : process.env.REACT_APP_API_DEV_URL
// Server should return AuthModel
export function login(props: any) {
  return axios.post(`${API_URL}/user/login`, {...props})
}

export function otpLogin(props: any) {
  return axios.post(`${API_URL}/user/otp_login`, {...props})
}

export function updateOtpValidity(props: any) {
  return axios.post(`${API_URL}/user/update_otp_validity`, {...props})
}

export function resentOtpCode(props: any) {
  return axios.post(`${API_URL}/user/send_otp_code`, {...props})
}

export function autoRefresh(props: any) {
  return axios.post(`${API_URL}/auth/refresh_data`, {...props})
}
